var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22222 17C10.3333 13.8 13.4444 10.9346 13.4444 7.4C13.4444 3.86538 10.6587 1 7.22222 1C3.78579 1 1 3.86538 1 7.4C1 10.9346 4.11111 13.8 7.22222 17Z",
    stroke: "#384F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22233 9.889C8.69513 9.889 9.889 8.69513 9.889 7.22233C9.889 5.74958 8.69513 4.55566 7.22233 4.55566C5.74953 4.55566 4.55566 5.74958 4.55566 7.22233C4.55566 8.69513 5.74953 9.889 7.22233 9.889Z",
    stroke: "#384F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.43fdef8667b62f628d1d718ed1a0a1f7.svg";
export { ForwardRef as ReactComponent };